import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LandingPageService } from '../../../services/landing-page.service';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { LOCID } from '../../../constants';
import { PatientCaseViewDataModel } from '../../../models/patient/patient-case-view-data.model';
import { UiService } from '../../../services/ui.service';
import { Subscription } from 'rxjs';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { TdoNoteQueryModel } from '../../controls/tdo-notes/models/tdo-note-query.model';
import { NotesService } from '../../../services/notes.service';
import { SignalrService } from '../../../services/socket/signalr.service';
import { StaticDataService } from "../../../services/static-data.service";
import { EnumValidValueItemModel } from "../../../models/enum/enum-valid-value-item.model";
import { DialogService } from "../../../services/dialog.service";
import { CaseService } from "../../../services/case.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { CaseEditDialogComponent } from "../../../dialog/case-edit-dialog/case-edit-dialog.component";

@Component({
  selector: 'app-home-cases-view',
  templateUrl: './home-cases-view.component.html',
  styleUrls: ['./home-cases-view.component.scss']
})
export class HomeCasesViewComponent implements OnInit, OnDestroy {
  @ViewChild('caseList') caseList: ElementRef;

  @Input() isExpanded: boolean;

  patientCaseList: PatientCaseViewDataModel[];
  selectedCaseItem: PatientCaseViewDataModel;
  lastCaseItem: PatientCaseViewDataModel;
  locid: number = 0;
  msgSub: Subscription;
  validValueSubscription: Subscription;
  getPatientsSubscription: Subscription;
  caseStatusEnums: EnumValidValueItemModel[] = [];
  isAllExpanded = false;

  constructor(private landingPageService: LandingPageService,
    private caseService: CaseService,
    private globals: Globals,
    private notesService: NotesService,
    private signalrService: SignalrService,
    private staticDataService: StaticDataService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private messagingService: MessagingService, private uiService: UiService) { }

  ngOnInit(): void {
    if (localStorage.getItem(LOCID)) {
      this.locid = parseInt(localStorage.getItem(LOCID));
    }
    if (this.staticDataService.isReady) {
      this.setupEnums();
    }
    else if (!this.validValueSubscription) {
      this.validValueSubscription = this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
      this.staticDataService.refreshValues(true, false, false);
    }


    this.msgSub = this.messagingService.componentMessageCall.subscribe(response => {
      this.ProcessComponentMessage(response);
    });

    this.signalrService.messageUser.subscribe((res) => {
      switch (res.messageType) {
        case SignalrService.UPDATE_TEETH:
        case MessagingConstants.CASES_REFRESH:
          if (res.message && res.message['patientId'] && res.message['patientId'] === this.globals.currentPatientId) {
            this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
              let patientCaseId = res.message['PatientCaseId'];
              if (!patientCaseId) {
                patientCaseId = this.selectedCaseItem.PatientCaseId;
              }
              this.patientCaseList = data;
              this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === patientCaseId);
              this.scrollToBottom();
              if (this.selectedCaseItem && res.messageType === MessagingConstants.CASES_REFRESH) {
                this.onCaseItemClick(null, this.selectedCaseItem);
              }
            });
          }
          break;
      }
    });

    this.initCases();
  }

  setupEnums() {
    this.caseStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseStatus');
  }

  isItemSelected(model: PatientCaseViewDataModel) {
    return this.selectedCaseItem === model;
  }

  onCaseItemClick(event: MouseEvent | null, model: PatientCaseViewDataModel) {
    if (event && event instanceof MouseEvent) {
      localStorage.setItem('isSelectedMTI', 'false');
    }
    if (model !== this.lastCaseItem) {

      localStorage.setItem('SelectedCaseDescription', `${model.Description} ${this.getTeeth(model.TeethList)} ${model.DateString}`);
      this.selectedCaseItem = model;
      this.uiService.selectedCaseItem = this.selectedCaseItem;
      this.globals.currentPatientCaseId = this.selectedCaseItem.PatientCaseId;
      this.globals.currentParentPatientCaseId = this.selectedCaseItem.Case.ParentPatientCaseId;
      if (localStorage.getItem('isSelectedMTI') !== 'true') {
        this.globals.currentPatientCaseWorkItemID = null;
      }
      this.globals.currentPatientCaseWorkItemFormsID = null;
      this.globals.save();

      this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, this.selectedCaseItem);

      const noteQueryModel = new TdoNoteQueryModel();
      noteQueryModel.parentObjectName = 'dataPatientCase';
      noteQueryModel.objectId = this.selectedCaseItem.PatientCaseId;
      noteQueryModel.patientId = this.globals.currentPatientId;
      this.notesService.changeNoteQuery(noteQueryModel);
    }
    this.lastCaseItem = this.selectedCaseItem;
  }

  private initCases(): void {
    this.patientCaseList = [];


    if (this.globals.currentPatientId) {
      this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
        this.patientCaseList = data;
        this.scrollToBottom();

        if (this.patientCaseList.length === 0) {
          this.globals.currentPatientSelectedCaseItem = {};
          this.globals.currentPatientCaseId = null;
          this.globals.currentParentPatientCaseId = null;
          this.globals.save();
          this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, null);
        } else {
          this.selectedCaseItem = this.patientCaseList[this.patientCaseList.length - 1];
          this.uiService.selectedCaseItem = this.selectedCaseItem;
          this.globals.currentPatientSelectedCaseItem = this.selectedCaseItem;
          this.globals.currentPatientCaseId = this.selectedCaseItem.PatientCaseId;
          this.globals.currentParentPatientCaseId = this.selectedCaseItem.Case.ParentPatientCaseId;
          this.globals.save();

          this.messagingService.sendComponentMessage(MessagingConstants.CASE_CHANGED_EVENT, this.selectedCaseItem);

          const noteQueryModel = new TdoNoteQueryModel();
          noteQueryModel.parentObjectName = 'dataPatientCase';
          noteQueryModel.objectId = this.selectedCaseItem.PatientCaseId;
          noteQueryModel.patientId = this.globals.currentPatientId;
          this.notesService.changeNoteQuery(noteQueryModel);

          this.lastCaseItem = this.selectedCaseItem;
        }
      },
        error => {
          console.log(error);
        }
      );
    }
  }

  scrollToBottom() {
    const ivl = setInterval(() => {
      if (!this.caseList) {
        return;
      }
      clearInterval(ivl);
      this.caseList.nativeElement.scrollTop = this.caseList.nativeElement.scrollHeight;
    }, 100);
  }

  getTeeth(teeth: string[]) {
    if (!teeth || teeth.length === 0) {
      return '';
    } else if (teeth.length <= 3) {
      let str = '';
      for (let i = 0; i < teeth.length; i++) {
        if (i !== teeth.length - 1) {
          str += teeth[i] + ', ';
        } else {
          str += teeth[i];
        }
      }
      return '# ' + str;
    } else {
      const sub = teeth[0].toString() + ', ' + teeth[1].toString() + ', ' + teeth[2].toString() + '...';
      return '# ' + sub;
    }
  }

  getStatus(enumCaseStatusID: string) {
    if (this.caseStatusEnums) {
      if (enumCaseStatusID) {
        const enu = this.caseStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumCaseStatusID.toLowerCase());
        if (enu) {
          return enu.ItemDisplayValue;
        } else {
          return this.caseStatusEnums[0]?.ItemDisplayValue;
        }
      } else {
        return this.caseStatusEnums[0]?.ItemDisplayValue;
      }
    }
  }

  getStatusImage(enumCaseStatusID: string) {
    if (this.caseStatusEnums) {
      if (enumCaseStatusID) {
        const enu = this.caseStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumCaseStatusID.toLowerCase());
        if (enu) {
          return enu.IconIDSVG;
        } else {
          return this.caseStatusEnums[0]?.IconIDSVG;
        }
      } else {
        return this.caseStatusEnums[0]?.IconIDSVG;
      }
    }
  }

  addNewCase() {
    const config = new MatDialogConfig();
    config.data = { caseItem: null, mode: 'newCase' };
    config.panelClass = 'dialog';

    this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.initCases();
      }
    });
  }

  addChildCase() {
    const config = new MatDialogConfig();
    config.data = { caseItem: this.selectedCaseItem, mode: 'newChildCase', allCases: this.patientCaseList };
    config.panelClass = 'dialog';

    this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.initCases();
      }
    });
  }

  editCase() {
    const config = new MatDialogConfig();
    config.data = { caseItem: this.selectedCaseItem, mode: 'editCase', allCases: this.patientCaseList };
    config.panelClass = 'dialog';

    this.dialog.open(CaseEditDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.initCases();
      }
    });
  }

  deleteCase() {
    this.dialogService.openConfirmDialog('Are you sure you want to delete ' + this.selectedCaseItem.Description + ' ' + this.selectedCaseItem.DateString + '?').subscribe((res) => {
      if (res) {
        this.caseService.deleteCase(this.selectedCaseItem.PatientCaseId).subscribe(() => {
          const idx = this.patientCaseList.findIndex(p => p.PatientCaseId.toLowerCase() === this.selectedCaseItem.PatientCaseId.toLowerCase());
          if (idx > -1) {
            this.patientCaseList.splice(idx, 1);
            if (this.patientCaseList.length > 0) {
              this.selectedCaseItem = this.patientCaseList[0];
            }
          }
        });
      }
    });
  }

  expandAll() {
    this.isAllExpanded = true;
    for (const cse of this.patientCaseList) {
      cse.isExpanded = true;
    }
  }

  collapseAll() {
    this.isAllExpanded = false;
    for (const cse of this.patientCaseList) {
      cse.isExpanded = false;
    }
  }

  ProcessComponentMessage(response) {
    if (response.event === MessagingConstants.PATIENT_LOADED) {
      this.initCases();
    }
    else if (response.event === MessagingConstants.CASES_REFRESH_SELECT_CASE) {
      this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
        this.patientCaseList = data;
        this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data.parentCaseId);
        this.scrollToBottom();
        if (this.selectedCaseItem) {
          // trigger dropdown of subitems
          if (this.selectedCaseItem.Case.ChildCases.length > 0) {
            this.selectedCaseItem.isExpanded = true;
            // select first child case item
            this.selectedCaseItem = this.selectedCaseItem.Case.ChildCases[0];
          }
          this.lastCaseItem = null;
          this.onCaseItemClick(null, this.selectedCaseItem);
        }
      });
    }
    else if (response.event === MessagingConstants.CASES_REFRESH) {
      this.getPatientsSubscription = this.landingPageService.getPatientsCases4Landing(this.globals.currentPatientId).subscribe((data) => {
        this.patientCaseList = data;
        this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data);
        this.scrollToBottom();
        if (this.selectedCaseItem) {
          this.onCaseItemClick(null, this.selectedCaseItem);
        }
      });
    }
    else if (response.event === MessagingConstants.ONLY_CASES_STATUS_REFRESH) {
      if (response.data.PatientCaseId) {
        this.getPatientsSubscription = this.caseService.getPatientCaseById(response.data.PatientCaseId).subscribe((data) => {
          this.selectedCaseItem = this.patientCaseList.find(p => p.PatientCaseId === response.data.PatientCaseId);
          this.selectedCaseItem.Case.enumCaseStatusID = data.enumCaseStatusID;
          this.scrollToBottom();
        });
      }
    }
  }
  ngOnDestroy() {
    if (this.validValueSubscription)
      this.validValueSubscription.unsubscribe();
    if (this.msgSub)
      this.msgSub.unsubscribe();
    if (this.getPatientsSubscription)
      this.getPatientsSubscription.unsubscribe();
  }
}
